export default function reducer(
  state = {
    loading: false,
    error: false,
    deviceInfo: {}
  },
  action
) {
  switch (action.type) {
    case 'TOGGLE_IS_DESKTOP':
      return {
        ...state,
        deviceInfo: {
          ...state.deviceInfo,
          isDesktop: action.isDesktop
        }
      };
    default:
      return state;
  }
}
